import * as React from "react"
import "../styles/components/fullScreenBackground.scss"

export default function FullScreenBackground(props) {
  return <img className="fullScreenBg" src={props.src} alt={props.alt} />
}
